import styled from "styled-components";

export const ProfileModalContainer = styled.div`
  width: 37%;
  height: 87vh;

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background: #2c2c2c94;
    z-index: 10;
  }
`;
export const ProfileModalWrapper = styled.div`
  height: 100%;
  width: 100%;
  background: #fff;
  overflow-y: scroll;
  border-radius: 10px;
  @media (max-width: 768px) {
    height: 100vh;
    border-radius: 0;
  }

  &::-webkit-scrollbar {
    width: 2px;
    border-radius: 3px;
    background-color: #00000020;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #000000ce;
    width: 2px;
    border-radius: 3px;
  }
`;

export const ProfileNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;

  div:nth-child(1) {
    display: flex;
    align-items: center;
    color: black;
    border-radius: 8px;
    margin: 10px 5px;
    padding: 7px;
    text-align: center;
    font-size: 18px;
    transition: 0.3s ease;
    &:hover {
      cursor: pointer;
      background: #b8b8b88a;
    }
    @media (max-width: 768px) {
      margin: 0;
      padding: 7px;
    }
  }
  div:nth-child(2) {
    background: #fff;
    border: 1px solid #b8b8b8;
    color: black;
    align-items: center;
    padding: 3px;
    border-radius: 8px;
    display: none;
    gap: 0;
    @media (max-width: 768px) {
      display: flex;
    }

    span:nth-child(2) {
      color: #b8b8b88a;
    }
    span:nth-child(1),
    span:nth-child(3) {
      border-radius: 5px;
      display: flex;
      align-items: center;
      text-align: center;
      padding: 5px 10px;
      font-size: 18px;
      &:hover {
        cursor: pointer;
        background: #b8b8b88a;
      }
    }
  }
`;
export const ProfileDetails = styled.div`
  border-radius: 5px;
  padding: 7px;
  margin: 10px;
  border: 1px solid #ccccccc1;
  background: #b8b8b827;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
`;

export const ProfileImageDetails = styled.div`
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 5px;

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }
  div {
    width: 80%;
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 0;

    span {
      display: inline-block;
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span:nth-child(1) {
      text-transform: capitalize;
      font-weight: 600;
      color: #000;
      font-size: 16px;
    }
    span:nth-child(2) {
      font-size: 13px;
      text-transform: lowercase;
    }
  }
`;
export const ProfileBio = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 2px;
  padding: 3px;

  span:nth-child(1) {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
  }
  span:nth-child(2) {
    color: black;
    font-size: 14px;
  }
`;

export const ProfileButton = styled.div`
  border-top: 1px solid #ccccccc1;
  display: flex;
  align-items: flex-start;
  padding: 10px;
  flex-direction: column;
  gap: 10px;
  div {
    border-radius: 5px;
    padding: 10px;
    color: black;
    gap: 10px;
    width: 92%;
    display: flex;
    align-items: center;
    border: 1px solid transparent;
    &:hover {
      border: 1px solid #ccccccc1;
      background: #bab9b954;
      cursor: pointer;
      opacity: 0.9;
    }
    span {
      text-transform: capitalize;
      font-size: 14px;
    }
  }
`;
